import React, { useEffect, useState } from "react";
import Checkbox from "@mui/material/Checkbox";
import { GetBaseUrl } from "./modules/getBaseUrl";
import { useSelector } from "react-redux";

const label = { inputProps: { "aria-label": "Checkbox demo" } };
const decData = [
  "I understand that I have certain rights that I enjoy as a data principal over my personal data / personal information, in relation to its collection, use and processing. These rights relate to confirmation and access, correction and erasure, objection of disclosure, and portability of my personal information.",
  "I hereby, give my consent to IDFC FIRST Bank (“Bank”) that my personal information (including my photographs and testimonials) submitted with the Bank, can be shared with appropriate systems/platforms involved with processing applications for the scholarship program, or for promotional activities with external or internal agencies by the Bank.",
  "I understand that, to check my eligibility for the scholarship program and for other related purposes, Bank needs to store my personal data or to share my personal information on different platforms, different departments within Bank and I fully understand that this personal information may be collected, used, and disclosed by the Bank. I hereby give consent to Bank, to share my personal information within their departments that are responsible for each stage of processing my application with the scholarship program including but not limited to, Document Verification, RCU checks, Payments etc.",
  "I confirm that my personal information is being collected only with my valid consent, and that such information may be used by Bank as they deem appropriate.",
  "I understand that laws relating to data privacy and/or related regulations may change, which may require further positive affirmation from my side, in addition to this consent.",
];
function Declaration(props) {
  const [checkBoxes, setCheckBoxes] = useState({ box1: false, box2: false });
  const tokenData = useSelector((state) => state.tokens.tokens);
  const [link, setLink] = useState("");
  useEffect(() => {
    let url = GetBaseUrl(window.location.href);
    setLink(url);
  }, []);
  useEffect(() => {
    props?.onChange({...checkBoxes})
  }, [checkBoxes]);
  return (
    <div className="form-section declaration-form">
      <p className="declaration-title">Declaration</p>
      <div className="form-content">
        {/* < /> */}
        <div className="field-item">
          <Checkbox
            {...label}
            // defaultChecked
            checked={checkBoxes.box1}
            onChange={() =>
              setCheckBoxes({ ...checkBoxes, box1: !checkBoxes.box1 })
            }
            sx={{
              color: "#951B30",
              "&.Mui-checked": {
                color: "#951B30",
            }
            }}
          />
          <span className="title">
            I agree to the{" "}
            <a
              href={`${link}/terms/${[ "B.Tech", "B.E."].includes(tokenData?.registrationData?.degree)?'eng':"mba"}`}
              target="_blank"
              rel="noreferrer"
            >
              Terms & Conditions
            </a>
          </span>
        </div>
        <div className="field-item">
          <Checkbox
            {...label}
            onChange={() =>
              setCheckBoxes({ ...checkBoxes, box2: !checkBoxes.box2 })
            }
            checked={checkBoxes.box2}
            // defaultChecked
            sx={{
              color: "#951B30",
              "&.Mui-checked": {
                color: "#951B30",
              },
            }}
          />
          <span className="title">
            I agree to the{" "}
            <a
              href={`${link}/policy`}
              target="_blank"
              rel="noreferrer"
            >
              Data Sharing Policy
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}

export default Declaration;
